<template>
  <div class="footerParent">
    <div :class="[isMarginTop ? 'footer1' : 'footer']" >
      <div class="footerLeft">
        <img :src="leftLogo" alt="" class="imgCss">
        <div class="leftTextparent">
          <div class="leftText">智见未来</div>
          <div class="leftTextBottom">
            <span>屏幕化社会</span>
            <span>屏幕化服务</span>
            <span>屏幕化生活</span>
          </div>
        </div>

      </div>
      <div class="footerRight bottomFlex">
        <div class="bottomLeft">
          <div>联系方式</div>
          <div class="spanText">
            售前咨询
            <span>400-640-0088</span>
          </div>
          <div class="spanText">
            设计咨询
            <span>400-640-0088</span>
          </div>
          <div class="spanText">
            客服咨询
            <span>400-640-0088</span>
          </div>
          <div class="marginTop32">公司地址</div>
          <div class="spanText marginTop30">
            西安市锦业一路西安软件园C座402
            <div class="marginTop10">深圳市南山区前海路振业同创汇320</div>
          </div>
        </div>
        <div>
          <img :src="erweima" alt="" class="erweima">
        </div>

      </div>

    </div>
    <div class="bgColor">
      <div class="lineCss"></div>
      <div class="footerFlex">
        <!-- <div class="footerFlexBox"  @click="toLink"></div> -->
        <div class="footerFlexBox" style="cursor: default;" >
          <span @click="toLink" style="cursor:pointer;">
            {{urlIsShutuo ? instwallOrShutuoTv : "粤ICP备2021061593号-1"}}
          </span>
        </div>
        <div class="footerFlexBox"  style="cursor: default;">
          <span @click="toLinkTwo"  style="cursor:pointer;">
            
            {{urlIsShutuo ? '陕公网安备61019002000506号' : '粤公网安备44030502007400号'}}
          </span>
        </div>
        <!-- <div class="footerFlexBox" @click="toLink">陕公网安备61019002000505号</div> -->
      </div>

    </div>

  </div>

</template>
<script>
  import leftLogo from "@/assets/images/leftLOGO.png"
  import erweima from "@/assets/images/erweima.png"

  export default {
    name: 'Footer',
    props:['isMarginTop'],
    data() {
      return {
        defaultOpenKey: '',
        leftLogo: leftLogo,
        erweima: erweima,
        shuTuoBol : "",
        urlIsShutuo: true,
        instwallOrShutuoTv: '陕ICP备14004077号'
      }
    },
    mounted(){
      var hrefSrc = window.location.href;
      // var hrefSrc = 'https://www.shutuo.tv/'
      console.log(hrefSrc)
      console.log(hrefSrc.indexOf('djs'))
      if(hrefSrc.indexOf('djs') == -1){
        this.shuTuoBol = true;
      }else{
        this.shuTuoBol = false;
      }

      if(hrefSrc.indexOf('showtop') == -1){
        console.log(111)
        this.urlIsShutuo = true;
        if(hrefSrc.indexOf('instwall') == -1){
          
          // 是 shutuo.tv
          this.instwallOrShutuoTv = '陕ICP备14004077号'
        }else{
          this.instwallOrShutuoTv = '陕ICP备10203521号'
        }
      }else{
        console.log(222)
        
        this.urlIsShutuo = false;
      }
    },
    methods:{
      toLink(){
        window.open('https://beian.miit.gov.cn', "_blank");
      },
      toLinkTwo(){
        if(this.urlIsShutuo){
          window.open('http://www.beian.gov.cn/portal/registerSystemInfo?recordcode=61019002000506', "_blank");
        }else{
          window.open('http://www.beian.gov.cn/portal/registerSystemInfo?recordcode=44030502007400', "_blank");
        }
      }
    }

  }

</script>
<style scoped>
  .footer {
    height: 400px;
    margin-top: 87px;
  }
  .footer1 {
    height: 400px;
  }

  .footerParent {
    background: rgba(0, 0, 0, 1);
  }

  .bgColor {
    background: rgba(0, 0, 0, 1);

  }

  .marginTop10 {
    margin-top: 10px;
  }

  .marginTop30 {
    margin-top: 30px;
  }

  .marginTop32 {
    margin-top: 32px;
  }

  .erweima {
    margin-top: 24px;
  }

  .footer::after {
    content: "";
    display: block;
    clear: both;
  }

  .footerLeft {
    width: 50%;
    float: left;
    margin-top: 70px;


  }

  .footerRight {
    width: 50%;
    float: right;
    margin-top: 79px;
  }

  .imgCss {
    /* border: 1px dashed #fff; */
    margin-left: 290px;
  }

  .leftText {
    font-size: 2rem;
    font-family: PingFangSC-Light;
    font-weight: 300;
    color: rgba(255, 255, 255, 1);
    line-height: 40px;
    margin-top: 120px;
  }

  .leftTextBottom {
    font-size: 1.8rem;
    font-family: PingFangSC-Light;
    font-weight: 300;
    color: rgba(255, 255, 255, 1);
    line-height: 40px;
  }

  .leftTextparent {
    text-align: left;
    margin-left: 290px;
  }

  .bottomFlex {
    display: flex;
  }

  .bottomLeft {
    width: 260px;
    text-align: left;
    font-size: 1.4rem;
    font-family: PingFangSC-Regular;
    font-weight: 400;
    color: rgba(255, 255, 255, 1)
  }

  .spanText {
    color: rgba(96, 96, 96, 1);
    margin-top: 16px;
  }

  .spanText span {
    display: inline-block;
    margin-left: 33px;
  }

  .lineCss {
    height: 1px;
    border-bottom: 1px solid #808080;
    margin-bottom: 15px;
    width: 70%;
    margin: auto;
  }

  .footerFlex {
    width: 570px;
    display: flex;
    margin: auto;
    font-size:.7rem;
    -webkit-text-size-adjust:none;
    font-family: PingFangSC-Light;
    font-weight: 300;
    color: rgba(128, 128, 128, 1);
    line-height: 42px;
  }

  .footerFlexBox {
    /* flex-grow: 1; */
    width: 50%;
    white-space:normal; 
    word-break: normal;
    cursor: pointer;
  }
  @media screen and (max-width: 1125px) {
    .leftTextparent {
        margin-left: 140px;
    }
    .imgCss{
        margin-left: 140px;
    }
}

</style>



// WEBPACK FOOTER //
// src/components/footer.vue